'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var ndjson = require('iterable-ndjson');

var Big = require('bignumber.js');

var configure = require('../lib/configure');

var toIterable = require('stream-to-it/source');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _bw = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
      var searchParams, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, stats;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              searchParams = new URLSearchParams(options.searchParams);
              if (options.interval) searchParams.set('interval', options.interval);
              if (options.peer) searchParams.set('peer', options.peer);
              if (options.poll != null) searchParams.set('poll', options.poll);
              if (options.proto) searchParams.set('proto', options.proto);
              _context.next = 8;
              return _awaitAsyncGenerator(ky.post('stats/bw', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: searchParams
              }));

            case 8:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 11;
              _iterator = _asyncIterator(ndjson(toIterable(res.body)));

            case 13:
              _context.next = 15;
              return _awaitAsyncGenerator(_iterator.next());

            case 15:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 19;
              return _awaitAsyncGenerator(_step.value);

            case 19:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 27;
                break;
              }

              stats = _value;
              _context.next = 24;
              return {
                totalIn: new Big(stats.TotalIn),
                totalOut: new Big(stats.TotalOut),
                rateIn: new Big(stats.RateIn),
                rateOut: new Big(stats.RateOut)
              };

            case 24:
              _iteratorNormalCompletion = true;
              _context.next = 13;
              break;

            case 27:
              _context.next = 33;
              break;

            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](11);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 33:
              _context.prev = 33;
              _context.prev = 34;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 38;
                break;
              }

              _context.next = 38;
              return _awaitAsyncGenerator(_iterator.return());

            case 38:
              _context.prev = 38;

              if (!_didIteratorError) {
                _context.next = 41;
                break;
              }

              throw _iteratorError;

            case 41:
              return _context.finish(38);

            case 42:
              return _context.finish(33);

            case 43:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[11, 29, 33, 43], [34,, 38, 42]]);
    }));

    function bw(_x) {
      return _bw.apply(this, arguments);
    }

    return bw;
  }();
});